export type UserRole =
  | 'ANR_ADMIN'
  | 'ANR_OFFICER'
  | 'CNS_ADMIN'
  | 'CNS_OFFICER'
  | 'ONT_ADMIN'
  | 'ONT_OFFICIAL'
  | 'SUPER_ADMIN';

/** Backend SystemUser JSON shape (snake_case from Go) */
export interface SystemUser {
  id: string;
  email: string;
  full_name: string;
  role: UserRole;
  organization: string;
  is_active: boolean;
  last_login?: string | null;
  created_at: string;
  updated_at: string;
}

export interface UserFormData {
  email: string;
  password?: string;
  full_name: string;
  role: UserRole;
  organization: string;
}

export interface UserActivity {
  id: string;
  user_id: string;
  user_role?: string;
  action: string;
  resource: string;
  resource_id?: string;
  ip_address?: string;
  user_agent?: string;
  timestamp: string;
  success: boolean;
  error_message?: string;
}

export interface UserStatistics {
  total_users: number;
  active_users: number;
  users_by_role: Record<string, number>;
  users_by_organization: Record<string, number>;
  recently_active_users: number;
}

export const ROLE_LABELS: Record<string, string> = {
  ANR_ADMIN: 'Administrateur ANR',
  ANR_OFFICER: 'Officier ANR',
};

export const ROLE_COLORS: Record<string, string> = {
  ANR_ADMIN: 'bg-indigo-100 text-indigo-800',
  ANR_OFFICER: 'bg-cyan-100 text-cyan-800',
};

/** Assignable roles — ANR dashboard only manages ANR users */
export const ASSIGNABLE_ROLES: UserRole[] = [
  'ANR_ADMIN',
  'ANR_OFFICER',
];
